<script>
export default {
  props: {
    onReportAlertClick: {
      type: Function,
      required: true,
    },
  },
}
</script>
